import styled from 'styled-components';

import { BottomServiceVariants } from './types';

const mapVariantToColor = (variant: BottomServiceVariants) => {
  switch (variant) {
    case BottomServiceVariants.IN_PROGRESS:
      return Styles.color.black;
    case BottomServiceVariants.DEFAULT:
    default:
      return Styles.color.validated;
  }
};

export const ButtonContainer = styled.div`
  grid-area: button;
  align-self: center;
  justify-self: center;
  display: flex;
  & > :not(:last-child) {
    margin-right: 0.625rem;
  }
`;

export const Container = styled.div<{ variant: BottomServiceVariants }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem;
  height: 4.125rem;
  background: ${props => mapVariantToColor(props.variant)};
  cursor: pointer;
  box-shadow: 0px 1px 4px ${Styles.color.background};
`;

export const IconContainer = styled.div`
  align-self: center;
  justify-self: center;
  grid-area: icon;
`;

export const BottomServiceWrapper = styled.div`
  max-width: ${Styles.layout.sectionMaxWidth};
  display: grid;
  grid-template-areas:
    'icon heading button'
    'icon details button';
  grid-template-columns: 2.5rem auto max-content;
  width: 100%;
`;

export const Heading = styled.div`
  grid-area: heading;
  font-family: ${Styles.fontFamily.base};
  font-size: 1.125rem;
  color: ${Styles.color.white};
  padding: 0 0.625rem;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0.75rem;
`;

export const Details = styled.div`
  grid-area: details;
  color: ${Styles.color.white};
  padding: 0 0.625rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0.75rem;
`;
